import { getExtensionValue } from "@medplum/core";
import { Procedure } from "@medplum/fhirtypes";

import { deriveDotPhrasePlainText, sanitizeDotPhraseBodyHtml } from "@/dot-phrases";
import { Extensions } from "@/fhir/enums/extensions";
import { plainTextToHtml } from "@/utils/rich-text";

const NOTE_DOCUMENT_PATTERN = /^\s*<(p|ul|ol)[\s>]/i;

const projectNoteText = (stored: string): string =>
  NOTE_DOCUMENT_PATTERN.test(stored) ? deriveDotPhrasePlainText(stored) : stored;

export const readProcedureNoteSource = (
  procedure: Procedure | undefined,
  url: Extensions,
): string => {
  const notes = procedure && getExtensionValue(procedure, url);

  return typeof notes === "string" ? notes : "";
};

export const readProcedureNoteText = (procedure: Procedure | undefined, url: Extensions): string =>
  projectNoteText(readProcedureNoteSource(procedure, url));

export const toProcedureNoteHtml = (source: string): string =>
  NOTE_DOCUMENT_PATTERN.test(source) ? sanitizeDotPhraseBodyHtml(source) : plainTextToHtml(source);
